export default __webpack_public_path__ + "static/media/DSC01275.f519badf.webp";